import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Farmer from '@/views/Farmer.vue';
import MantissSnek from '@/views/MantissSnek.vue';
import Manager from '@/views/Manager.vue';
import Home from '@/views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Farmer',
    component: Farmer,
  },
  {
    path: '/mantiss-special-farm',
    name: 'Mantiss Snek',
    component: MantissSnek,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
